<div class="sub-chrome-container" [class.from-page-home]="fromPage" *ngIf="isViewVisible">
    <div class="title-area" kendoTooltip>
        <span class="h1-light text-ellipsis" tamDynamicTooltip [title]="screenInfo.name">{{screenInfo.name}}</span>
        <div class="focus-box" *ngIf="showFocus">
            <kendo-combobox [popupSettings]="{width: 350, popupClass: 'popup-dashboard-view-sub-chrome'}" #finder [data]="finderDS" textField="shortName"
                valueField="id" [(ngModel)]="selectItem" [listHeight]="420" [loading]="isFinderLoading"
                [filterable]="true" (ngModelChange)="onFinderValueChange($event)"
                (filterChange)="onFinderFilterChange($event)" style="width: 350px;" [virtual]="virtualizationSetting"
                (focus)="onFinderFocus()">
                <ng-template kendoComboBoxItemTemplate let-dataItem>
                    <tam-entity-dropdown-item [entity]="dataItem"></tam-entity-dropdown-item>
                </ng-template>
            </kendo-combobox>
        </div>
        <div class="degree-box" *ngIf="isOneDegreeShown">
            <button tid="focus_one_degree" tam-button tamType="primary" [tamInvert]="!isOneDegreeChecked"
            (click)="onOneDegreeChange($event)">1&deg;</button>
        </div>
    </div>
    <div class="operation-box">
        <ng-container class="edit-operations" *ngIf="isEditView">
            <button tam-button tamType="tertiary" tamSize="normal" (click)="onCancel()">{{'general.cancel' | stringLiterals}}</button>
            <button tam-button tamType="secondary" tamSize="normal" (click)="onEditClick()">{{'dashboard.edit_details' | stringLiterals}}</button>
            <button tam-button tamType="primary" tamSize="normal" (click)="onSave()"
                [tamLoading]="saveBtnLoading">{{'general.save' | stringLiterals}}</button>
        </ng-container>
        <ng-container class="view-operations" *ngIf="!isEditView">
            <button tam-button tamType="primary" tamSize="normal" (click)="onDashboardEditClick()"
                *ngIf="showOperateButton && !config.fromPage">{{'dashboard.edit_dashboard' | stringLiterals}}</button>
            <div *ngIf="!this._isIPAD" class="meatball-operate" (click)="showContextMenu($event)">
                <smart-icon name="meatball" class="light"></smart-icon>
            </div>
            <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
        </ng-container>
    </div>
</div>
